// For more selectors, view:
// https://github.com/duskload/react-device-detect/blob/master/docs/selectors.md
import { isMobileOnly, isTablet, isDesktop } from 'react-device-detect';
import type { DeviceType } from './useAppContext';
const useDeviceType = () => {
  const deviceType: DeviceType = isDesktop
    ? 'desktop'
    : isMobileOnly
    ? 'phone'
    : 'tablet';

  const isPhone = isMobileOnly ? 'phone' : false;
  const isMobile = isMobileOnly && 'mobile';

  return {
    deviceType,
    isMobileOnly,
    isTablet,
    isDesktop,
    isPhone,
    isMobile,
  };
};

export default useDeviceType;
